import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "features/auth/reducer";
import calendarReducer from "features/calendar/reducer";
import globalReducer from "features/global/reducer";
import homeReducer from "features/home/reducer";
import userReducer from "features/user/reducer";

const rootReducer = combineReducers({
    auth: authReducer,
    calendar: calendarReducer,
    global: globalReducer,
    home: homeReducer,
    user: userReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
